const env = import.meta.env;

export const BASE_URL = (() => {
  const phase = env.VITE_APP_PHASE;
  const localBaseUrl = localStorage.getItem("baseURL");
  if (["develop", "local"].includes(phase) && localBaseUrl) {
    return localBaseUrl;
  }
  if (["production", "develop", "local"].includes(phase)) {
    return env.VITE_API_URL;
  }
  return "https://api.qbitpay.org";
})();

const BASE_TRANSACTION_URL = `${BASE_URL}/transactions`;
const BASE_PROFILE_URL = `${BASE_URL}/profile`;

export const ENDPOINTS = {
  auth: {
    logout: `${BASE_URL}/logout/`,
    login: `${BASE_URL}/otp/login/`,
    requestOtp: `${BASE_URL}/otp/request/`,
    checkOtp: `${BASE_URL}/otp/check/`,
    refreshToken: `${BASE_URL}/refresh-token/`,
  },

  profile: {
    profile: `${BASE_PROFILE_URL}/`,
    referral: `${BASE_PROFILE_URL}/referral/`,
    changePassword: `${BASE_PROFILE_URL}/change-password/`,
    removePassword: `${BASE_PROFILE_URL}/remove-password/`,
    announces: `${BASE_PROFILE_URL}/announces/`,
    setReferralr: `${BASE_URL}/set-inviter-by-code/`,
  },

  users: {
    sessions: `${BASE_URL}/users/sessions/`,
  },

  content: {
    appMetaData: `${BASE_URL}/contents/user/`,
    appData: "https://status.qbitpay.org/meta-data/user/",
  },

  media: {
    uploadImage: `${BASE_URL}/media/upload-image/`,
  },

  transactions: {
    base: `${BASE_TRANSACTION_URL}/`,
    getById: (id: string) => `${BASE_TRANSACTION_URL}/${id}/`,
    chargeWallet: `${BASE_TRANSACTION_URL}/charge-wallet/`,
    bankRedirect: `${BASE_TRANSACTION_URL}/redirect/`,
    chargePhone: `${BASE_TRANSACTION_URL}/charge-phone/`,
    internetPackage: `${BASE_TRANSACTION_URL}/internet-package/`,
    tollInquiry: `${BASE_TRANSACTION_URL}/toll/etc/inquiry/`,
    sepidInquiry: `${BASE_TRANSACTION_URL}/sepid/inquiry/`,
    sepidMerchant: (id: string) => `${BASE_TRANSACTION_URL}/sepid/${id}/pay/`,
    merchantWithQr: (qrId: string) => `${BASE_TRANSACTION_URL}/pay/merchant/qr/${qrId}/`,
    merchantWithCode: (code: string) => `${BASE_TRANSACTION_URL}/pay/merchant/code/${code}/`,
    bankUrl: (token: string) => `${BASE_TRANSACTION_URL}/redirect/${token}/`,
  },

  operators: {
    base: `${BASE_URL}/operators/`,
    internetPackages: `${BASE_URL}/internet-packages/`,
  },

  discount: {
    codeAmount: `${BASE_URL}/discount-codes/amount/`,
  },
} as const;
